import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import {
  AgGrid,
} from '../AgGrid'
import classnames from 'classnames'

const styles = theme => ({});

export const IndividualAccountingHistoryDetail = withStyles(styles)(props => {
  const { gridData } = props;

  const columnDefs = [
    {
      headerName: "Order Line ID",
      field: "orderlineId",
    },
    {
      headerName: "Order Line Total",
      field: "orderLineTotal",
    },
  ];
  const gridOptions = {
    // columnDefs: mainColumnDefinitions,
  };

  return (
    <div
      className={classnames(
        // 'flex-1', 
        'col-center-center'
      )}
      style={{
        position: "relative",
        height: 400,
        padding: 30,
        justifyContent: 'flex-start'
      }}
    >
      <AgGrid
        gridData={gridData}
        columnDefs={columnDefs}
        gridOptions={gridOptions}
        sideBar={false}
        floatingFilter={false}
        redirectOnClick={false}
        editOnClick={false}
      />
    </div>
  );
});

IndividualAccountingHistoryDetail.propTypes = {
  classes: PropTypes.object,
  gridData: PropTypes.array,
  onSave: PropTypes.func
};
